import { render, staticRenderFns } from "./MainMotorCurrent.vue?vue&type=template&id=5678d9a6&scoped=true&"
import script from "./MainMotorCurrent.vue?vue&type=script&lang=ts&"
export * from "./MainMotorCurrent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5678d9a6",
  null
  
)

export default component.exports